<template>
    <div>
        <!-- <data-grid
            url="sms?broadcastID="
            :columns="columns"
            :title="title"
            :actions="actions"
            :mapper="mapResults"
            :sortOptions="{
                enabled: true,
                field: 'dateTime',
                type: 'desc',
            }"
            ref="grid"
        ></data-grid> -->

        <dx-grid
            url="sms?broadcastID="
            :columns="columns"
            :title="title"
            :actions="actions"
            :onLoaded="mapResults"
            ref="grid"
        ></dx-grid>

        <v-dialog v-model="imageViewDialog" max-width="800">
            <v-card>
                <div v-for="image in clickedRow.images">
                    <v-img :src="image"></v-img>
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import moment from "moment";
import { getDomain } from "../utils/helpers.js";

export default {
    data: () => ({
        title: "SMS",
        imageViewDialog: false,
        clickedRow: "",
        actions: [],

        columns: [
            {
                field: "statusIcon",
                isIcon: true,
                template: "icon",
                alignment: "center",
                visible: true,
                allowFiltering: false,
                allowHeaderFiltering: false,
                allowHiding: false,
                allowSearch: false,
                cssClass: "width-25",
                headerFilter: {
                    allowSearch: false,
                    groupInterval: undefined,
                    height: undefined,
                    searchMode: "contains",
                    width: undefined,
                },
                icon: (value, row) => {
                    if (!value) return "";

                    switch (value.trim()) {
                        case "ERROR":
                        case "FAILED":
                            return "mdi-message-alert";
                        case "NEW":
                            return "mdi-message-plus";
                        case "QUEUED":
                        case "WAITING":
                        case "PENDING":
                            return "mdi-message-processing";
                        case "SENT":
                            return "mdi-comment-arrow-right";
                        case "UNKNOWN":
                            return "mdi-message-question";
                        case "DELIVERED":
                            return "mdi-message-text";
                        case "UNDELIVERED":
                            return "mdi-close-circle";
                        default:
                            return "";
                    }
                },
                iconColor: (value, row) => {
                    if (!value) return "";

                    switch (value.trim()) {
                        case "ERROR":
                        case "FAILED":
                        case "UNDELIVERED":
                            return "#f35123";
                        case "NEW":
                            return "info";
                        case "QUEUED":
                        case "WAITING":
                        case "PENDING":
                            return "#fdb400";
                        case "DELIVERED":
                            return "success";
                        case "SENT":
                        case "UNKNOWN":
                            return "#aeb8bf";
                        default:
                            return "#aeb8bf";
                    }
                },
            },
            {
                label: "Date",
                field: "dateTime",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                visible: true,
                sortOrder: "desc",
                sortIndex: 0,
                filterValues: [],
                filterValue: new Date(
                    moment()
                        .subtract(1, "week")
                        .add(1, "day"),
                ),
                selectedFilterOperation: ">=",
            },
            {
                label: "Name",
                field: "name",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Name Hebrew",
                field: "nameH",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Account ID",
                field: "accountId",
                link: (row) => {
                    return row.accountsSource == "DINNER"
                        ? "DinnerAccountView"
                        : "Account View";
                },
                format: "",
                template: "link-cell-template",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                showLink: (row) => {
                    return true;
                },
            },
            {
                label: "Direction",
                field: "direction",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "From",
                field: "from",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "To",
                field: "to",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Text",
                field: "text",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Attachment",
                field: "attachment",
                format: "",
                visible: true,
                template: "link-action-cell-template",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                showLink: (row) => {
                    return row.attachmentUrls;
                },
            },
            {
                label: "Status",
                field: "status",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Message Type",
                field: "messageType",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Error Code",
                field: "errorCode",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "User",
                field: "username",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Email",
                field: "emailAddress",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],
    }),
    watch: {},
    created() {
        this.columns.find(
            (c) => c.field == "attachment",
        ).linkAction = this.viewImage;

        this.actions.push({
            text: "Send Message",
            action: this.sendMessage,
        });
    },
    methods: {
        sendMessage() {
            this.$router.push({
                name: "SendMessage",
            });
        },
        mapResults(results) {
            return results.map((sms) => {
                sms.attachment = sms.attachmentUrls ? "Attachment" : "";

                return sms;
            });
        },
        viewImage(message) {
            const clickedRow = message;

            clickedRow.images = clickedRow.attachmentUrls.split(";");

            this.clickedRow = clickedRow;

            this.imageViewDialog = true;
        },
    },
};
</script>
<style>
[v-cloak] {
    display: none;
}

.border-line {
    border: black 1px solid;
}

.scroll {
    overflow-y: auto;
}
</style>
